<template>
  <div :class="`alert alert-danger alert-vanguard text-center ${className}`" :style="`top: ${top}`"><slot/></div>
</template>

<script>
export default {
  props: {
    className: {
      type: String,
      default: ''
    },
    top: {
      type: String,
      default: '0'
    }
  }
};
</script>



// WEBPACK FOOTER //
// alert.vue?66a22738